// src/components/Navbar.js  (o donde lo tengas)
import React, { useEffect, useMemo, useState } from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'

function getAuth() {
  const raw = localStorage.getItem('auth')
  if (raw) {
    try {
      const a = JSON.parse(raw)
      return {
        usuario: a?.usuario || a?.user || '',
        nombre: a?.nombre || a?.NombreUsuario || a?.name || '',
        correo: a?.correo || a?.Correo || '',
        rol: String(a?.rol || a?.role || '').toUpperCase(),
        maquinas: Array.isArray(a?.maquinas) ? a.maquinas : [],
      }
    } catch {}
  }

  // compatibilidad antigua
  const legacy = localStorage.getItem('usuario') || ''
  if (legacy) {
    return {
      usuario: legacy,
      nombre: legacy === 'Admin' ? 'Admin' : legacy,
      correo: '',
      rol: legacy === 'Admin' ? 'ADMIN' : 'USER',
      maquinas: [],
    }
  }

  return { usuario: '', nombre: '', correo: '', rol: '', maquinas: [] }
}

const Navbar = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(false)
  }, [location.pathname])

  const auth = useMemo(() => getAuth(), [])
  const rol = auth.rol || 'COCINA'

  const canAdmin = rol === 'ADMIN'
  const canCocina = rol === 'COCINA' || rol === 'ADMIN'
  const canAuditor = rol === 'AUDITOR' || rol === 'ADMIN'

  const handleLogout = () => {
    localStorage.removeItem('auth')
    localStorage.removeItem('usuario')     // legacy
    localStorage.removeItem('rut_almuerzo')// opcional
    navigate('/', { replace: true })
  }

  const usuarioLabel = useMemo(() => {
    const name = auth?.nombre?.trim()
    const user = auth?.usuario?.trim()
    return name || user || 'Usuario'
  }, [auth])

  const navLinkClass = ({ isActive }) =>
    `navbar-item nav-item ${isActive ? 'is-active' : ''}`

  return (
    <nav className="navbar comedor-navbar" role="navigation">
      <div className="navbar-brand">
        <NavLink to="/dashboard" className="navbar-item brand">
          🍽️ <span>Sistema Casino</span>
        </NavLink>

        <button
          className={`navbar-burger ${isOpen ? 'is-active' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
          aria-label="menu"
          aria-expanded={isOpen ? 'true' : 'false'}
          type="button"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className={`navbar-menu ${isOpen ? 'is-active' : ''}`}>
        <div className="navbar-start">
          {/* Operación diaria (COCINA y ADMIN) */}
          {canCocina && (
            <div className="navbar-item has-dropdown is-hoverable">
              <span className="navbar-link">Operación</span>
              <div className="navbar-dropdown">
                <NavLink to="/dashboard" className={navLinkClass}>Dashboard</NavLink>
                <NavLink to="/dashboard-sede" className={navLinkClass}> Dashboard Sede</NavLink>
                <NavLink to="/tickets" className={navLinkClass}>Tickets</NavLink>
                <NavLink to="/almuerzos" className={navLinkClass}>Ver Almuerzos</NavLink>
              </div>
            </div>
          )}

          {/* Menú y planificación (solo ADMIN) */}
          {canAdmin && (
            <div className="navbar-item has-dropdown is-hoverable">
              <span className="navbar-link">Menú</span>
              <div className="navbar-dropdown">
                <NavLink to="/menumes" className={navLinkClass}>Agregar Menú</NavLink>
                <NavLink to="/cargar-programacion" className={navLinkClass}>Cargar Programación</NavLink>
                <NavLink to="/pronostico" className={navLinkClass}>Pronóstico Mes</NavLink>
              </div>
            </div>
          )}

          {/* Personas (solo ADMIN) */}
          { (
            <div className="navbar-item has-dropdown is-hoverable">
              <span className="navbar-link">Personas</span>
              <div className="navbar-dropdown">
                <NavLink to="/buscar-rut" className={navLinkClass}>Buscar RUT</NavLink>
                <NavLink to="/crear-personal" className={navLinkClass}>Crear Personal</NavLink>
                <NavLink to="/listar-personal" className={navLinkClass}>Ver Personal</NavLink>
              </div>
            </div>
          )}

          {/* Administración (ADMIN y AUDITOR) */}
          {canAuditor && (
            <div className="navbar-item has-dropdown is-hoverable">
              <span className="navbar-link">Administración</span>
              <div className="navbar-dropdown">
                <NavLink to="/tickets-por-area" className={navLinkClass}>Tickets por Área</NavLink>
                <NavLink to="/reporte" className={navLinkClass}>Reporte</NavLink>
              </div>
            </div>
          )}

          {/* Usuarios (solo ADMIN) */}
          {canAdmin && (
            <NavLink to="/usuarios" className={navLinkClass}>
              👤 Usuarios
            </NavLink>
          )}
        </div>

        <div className="navbar-end">
          <div className="navbar-item user">
            👤 {usuarioLabel}
            <span className="tag is-light ml-2" style={{ marginLeft: 10 }}>
              {rol}
            </span>
          </div>

          <div className="navbar-item">
            <button className="button logout" onClick={handleLogout} type="button">
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .comedor-navbar {
          background: #ffffff;
          border-bottom: 1px solid #e5e7eb;
        }

        .brand {
          font-weight: 700;
          color: #15803d !important;
          gap: 8px;
        }

        .nav-item {
          color: #374151;
          border-radius: 8px;
        }

        .nav-item:hover {
          background: #f0fdf4;
          color: #15803d;
        }

        .nav-item.is-active {
          background: #dcfce7;
          color: #166534;
          font-weight: 600;
        }

        .navbar-dropdown {
          border-radius: 12px;
        }

        .user {
          background: #f8fafc;
          padding: 6px 14px;
          border-radius: 999px;
          font-size: 0.9rem;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .logout {
          background: #22c55e;
          color: white;
          border-radius: 999px;
          font-weight: 600;
        }

        .logout:hover {
          background: #16a34a;
        }
      `}</style>
    </nav>
  )
}

export default Navbar
